import { triniumApi } from '@api/Trinium/slice';
import { BrokerCarrier, transformBrokerCarriersResponse } from './types';

const brokersSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchBrokers: builder.query<
				BrokerCarrier[],
				{
					terminalNumber: string;
					startsWith?: string;
					isActive?: boolean;
				}
			>({
				query: ({ terminalNumber, startsWith, isActive }) => ({
					url: `/${terminalNumber}/brokers`,
					params: {
						startsWith,
						isActive
					}
				}),
				transformResponse: transformBrokerCarriersResponse
			})
		};
	}
});

export const { useFetchBrokersQuery, useLazyFetchBrokersQuery } = brokersSlice;
